import { withProps } from '@cast/design-system';

import { MetricsBox } from 'components/boxes';

export const SmallMetricsBox = withProps(MetricsBox, {
  markerProps: {
    width: '3px',
  },
  titleProps: {
    variant: 'L10R',
    lineHeight: '18px',
    letterSpacing: 1,
    noWrap: true,
    mb: 4,
  },
  primaryValueProps: {
    variant: 'h5',
    fontSize: '16px',
    lineHeight: '20px',
    fontWeight: 600,
    noWrap: true,
  },
  secondaryValueProps: {
    variant: 'P12R',
    sx: { opacity: 0.5, paddingLeft: '4px' },
  },
});
